// The agent closes an answer with the knowledge base's machine-readable
// `<!-- ctx ... -->` provenance footer. It is deliberately KEPT in the stored
// message content because the model reads it back from conversation history for
// drill-downs (report=/filters=, which the sources-derived history marker does
// not yet carry). It is NOT for the customer: the chat renders with
// react-markdown and no rehype-raw, and the model writes the comment inline (no
// blank line), so it surfaces as literal text. Strip it at every human-facing
// surface — chat render, copy, download — while leaving message.content intact.
//
// Tolerant of the `ctx:`/`ctx ` format drift and of an unterminated marker (the
// model dropping the closing `-->`).
export const stripCtxFooter = (content: string): string => {
  let text = content.replace(/\s*<!--\s*ctx\b[\s\S]*?-->/gi, '');
  const open = text.search(/<!--\s*ctx\b/i);
  if (open !== -1) {
    text = text.slice(0, open);
  }
  return text.trim();
};
